import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    alignSelf: 'center',
    gap: '1rem',
    marginBottom: '1rem',
  },
  table: {
    backgroundColor: theme.palette.container.background,
  },
  textField: {
    fontSize: '1.25rem',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
}));

export default useStyles;
